// ThemeToggle.js
//
// The gear in the menu bar. Dark is the design's home, and the light palette is
// the same one turned over — see main.css. Until the gear is touched the page
// follows the visitor's system preference; after that their choice sticks.

const STORAGE_KEY = "theme";

export class ThemeToggle {
  constructor(button) {
    this.button = button;
    this.root = document.documentElement;

    const stored = this.read();
    if (stored) {
      this.root.dataset.theme = stored;
    }

    this.reflect();
    this.button.addEventListener("click", () => {
      this.apply(this.isLight() ? "dark" : "light");
    });
  }

  apply(theme) {
    this.root.dataset.theme = theme;
    this.write(theme);
    this.reflect();
  }

  isLight() {
    const chosen = this.root.dataset.theme;
    if (chosen) {
      return chosen === "light";
    }

    return Boolean(window.matchMedia?.("(prefers-color-scheme: light)").matches);
  }

  // The label carries the state, spelled the way vim spells it. It is set in
  // the page's own face rather than an icon font or an emoji, so it looks the
  // same on every system.
  reflect() {
    const light = this.isLight();
    this.button.textContent = `bg=${light ? "light" : "dark"}`;
    this.button.setAttribute("aria-pressed", String(light));
  }

  // Private browsing and blocked site data both throw here, and a theme is not
  // worth taking the page down for.
  read() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  write(theme) {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
      // the choice lasts for this visit only
    }
  }
}
